Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconDashboardData: "data:image/svg+xml,%3csvg width='24' height='18' xmlns='http://www.w3.org/2000/svg'%3e%3cg stroke='currentColor' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M12 12l5-5M8 8L7 7M12 5v1M19 12h-1M5 12h1M17 7l-.758.757M2.2 17A10.95 10.95 0 011 12C1 5.925 5.925 1 12 1s11 4.925 11 11c0 1.801-.433 3.5-1.199 5'/%3e%3c/g%3e%3c/svg%3e",
  iconDashboardWidth: 24,
  iconDashboardHeight: 18
};